import { useNavigate } from 'react-router';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { AlertCircle, ArrowLeft, Home } from 'lucide-react';
import { StockImage, WarmMarketingBackdrop } from '../components/marketing/MarketingVisuals';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <WarmMarketingBackdrop>
      <div className="mx-auto flex min-h-screen max-w-6xl flex-col items-center justify-center gap-10 px-6 py-16 lg:flex-row lg:gap-14">
        <div className="relative w-full max-w-md overflow-hidden rounded-3xl border border-violet-200/60 shadow-2xl shadow-violet-900/15 lg:max-w-lg">
          <StockImage
            stockKey="coupleOutdoor"
            width={900}
            height={1100}
            priority
            alt="Warm, relaxed moment — illustrative stock photo"
            className="aspect-[4/5] w-full object-cover"
          />
          <div
            className="pointer-events-none absolute inset-0 bg-gradient-to-t from-violet-950/40 via-transparent to-transparent"
            aria-hidden
          />
        </div>

        <Card className="w-full max-w-md space-y-6 border-violet-100/90 bg-white/95 p-10 text-center shadow-xl lg:text-left">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-100 to-fuchsia-100 lg:mx-0">
            <AlertCircle className="h-8 w-8 text-violet-600" />
          </div>

          <div className="space-y-2">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet-600">404</p>
            <h1 className="text-3xl font-light text-neutral-900">Page not found</h1>
            <p className="text-neutral-600">
              The page you&apos;re looking for doesn&apos;t exist or has been moved.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center lg:justify-start">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="flex-1 gap-2 border-violet-200 bg-white/80"
            >
              <ArrowLeft className="h-4 w-4" />
              Go back
            </Button>
            <Button
              onClick={() => navigate('/')}
              className="flex-1 gap-2 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white shadow-md hover:opacity-95"
            >
              <Home className="h-4 w-4" />
              Home
            </Button>
          </div>
        </Card>
      </div>
    </WarmMarketingBackdrop>
  );
}
